"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import gql from "graphql-tag";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";
import type { AccommodationForm } from "./useCreateAccommodationForm";

interface UpdateAccommodationFormInput {
  id: string;
  formData: string;
}

interface UpdateAccommodationFormMutationVariables {
  input: UpdateAccommodationFormInput;
}

export const updateAccommodationFormMutation = gql`
  mutation updateAccommodationForm($input: UpdateAccommodationFormInput!) {
    updateAccommodationForm(input: $input) {
      id
      patientId
      episodeOfCareId
      status
      formData
      createdAt
      updatedAt
      submittedAt
      signedAt
      createdBy
    }
  }
`.loc?.source.body as GeneratedMutation<
  UpdateAccommodationFormMutationVariables,
  {
    updateAccommodationForm: AccommodationForm;
  }
>;

export const useUpdateAccommodationForm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: UpdateAccommodationFormMutationVariables) =>
      fetchGraphQLClient(updateAccommodationFormMutation, variables),
    onSuccess: (data) => {
      const form = data.data?.updateAccommodationForm;
      if (form) {
        queryClient.invalidateQueries({
          queryKey: ["accommodationForms", form.patientId],
        });
        queryClient.invalidateQueries({
          queryKey: ["accommodationFormsByEpisode", form.episodeOfCareId],
        });
        queryClient.invalidateQueries({
          queryKey: ["accommodationForm", form.id],
        });
      }
    },
  });
};
